import { IInvoicingConfig } from "@wingspanhq/payments/dist/interfaces";

export function getEnabledCurrencyFromConfig(config?: IInvoicingConfig) {
  if (!config?.allowOnlySelectedCurrencies.enabled) {
    return;
  }

  if (!Array.isArray(config.allowOnlySelectedCurrencies.value)) {
    return;
  }

  return config.allowOnlySelectedCurrencies.value[0];
}
